
<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <div v-if='btns.add'>
          <ejs-dropdownbutton :items='addOption' iconCss='icon hero-icon hero-icon-add' :select='dropDownAdd'></ejs-dropdownbutton>
        </div>
        <div v-if='btns.mod'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-edit" :title='$t("LteUser.modify")' @click='buttonClick("mod")'/></div>
        <div v-if='btns.del'>
          <ejs-dropdownbutton :items='removeOption' iconCss='icon hero-icon hero-icon-remove' :select='dropDownRemove'></ejs-dropdownbutton>
        </div>
        <div v-if='btns.qry'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-refresh" :title='$t("LteUser.refresh")' @click='buttonClick("qry")'/></div>
        <div class="e-toolbar-item e-separator" aria-disabled="false"></div>  
        <div v-if='btns.src' class="e-input-group" style="height:28px;">
          <input class="e-input" :placeholder='$t("Supi.supiSearch")' v-model='searchString' @input='searchChange("chg")' >
          <!-- <span class="icon hero-icon hero-icon-search "></span>  -->
        </div> 
        <div v-if='btns.src'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-search" :title='$t("LteUser.search")' @click='buttonClick("src")'/></div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'SupiTableMenu',
  data() {
    return {
      searchString: "",
      btns: {
        src: true,
        add: true,
        mod: true,
        del: true,
        qry: true
      },
      addOption: [
        {
          text: this.$t("LteUser.add"),
          value: 0
        },
        {
          text: this.$t("LteUser.addBatch"),
          value: 1
        }],
      removeOption: [
        {
          text: this.$t("LteUser.remove"),
          value: 0
        },
        {
          text: this.$t("LteUser.delRange"),
          value: 1
        }]
    };
  },
  methods: {
    buttonClick(event) {
      this.$emit('methodEnum', event);
    },
    searchChange(event) {
      this.$emit('methodEnum', event, this.searchString);      
    },
    dropDownAdd(args) {
      console.log('args',args)
      if (args.item.value === 0) {
        this.$emit('methodEnum', 'add');
      } else if (args.item.value === 1) {
        this.$emit('methodEnum', 'addBatch');
      }
    },
    dropDownRemove(args) {
      if (args.item.value === 0) {
        this.$emit('methodEnum', 'del');
      } else if (args.item.value === 1) {
        this.$emit('methodEnum', 'delRange');
      }
    },
  }
};
</script>

<style scoped>

</style>
